
import { useState, useEffect } from "react";
import { isPast } from "date-fns";
import { fetchUserSubscriptions } from "@/lib/supabase";
import { SubscriptionType } from "@/lib/supabase/types";
import { useAuth } from "@/lib/hooks/auth";

export const useUserSubscriptions = () => {
  const { user } = useAuth();
  const [userSubscriptions, setUserSubscriptions] = useState<SubscriptionType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  
  // Fetch user subscriptions
  useEffect(() => {
    const loadSubscriptions = async () => {
      // Get user ID either from auth context or localStorage as fallback
      const userId = user?.id || localStorage.getItem('userId');
      
      if (!userId) {
        setIsLoading(false);
        return;
      }
      
      setIsLoading(true);
      try {
        console.log("Fetching subscriptions for user:", userId);
        const subscriptions = await fetchUserSubscriptions(userId);
        
        const activeSubscriptions = subscriptions.filter(sub => 
          sub.active && 
          sub.remainingClasses > 0 && 
          !isPast(new Date(sub.expirationDate))
        );
        
        console.log("Active subscriptions:", activeSubscriptions);
        setUserSubscriptions(activeSubscriptions);
      } catch (error) {
        console.error('Error fetching user subscriptions:', error);
      } finally {
        setIsLoading(false);
      }
    };
    
    loadSubscriptions();
  }, [user]);

  return {
    userSubscriptions,
    isLoading,
    hasActiveSubscriptions: userSubscriptions.length > 0
  };
};
